export default {
    app: {
        name: 'Ãrea restrita Credenciamento MÃ©dico',
        shortName: 'ARM'
    },

    pagination: {
        currentPage: 1,
        totalPages: 1,
        pageSize: 30,
        totalItems: 0,
    },

    usuario: {
        id: localStorage.getItem('usuarioId') || '',
        nome: localStorage.getItem('nomeUsuario') || localStorage.getItem('usuarioLogado') || '',
        email: localStorage.getItem('usuarioLogado') || '',
        isAdmin: localStorage.getItem('isAdmin') === 'true',
        trocarSenha: localStorage.getItem('trocarSenha') === 'true',
        cpf: localStorage.getItem('cpf') || '',
        crm: localStorage.getItem('crm') || '',
        candidatoId: Number(localStorage.getItem('candidatoId')) || null,
        perfis: (() => {
            try { return JSON.parse(localStorage.getItem('perfis')) || []; }
            catch { return []; }
        })(),
    },

    minhaInscricao: {
        carregada: false,
        editalId: Number(localStorage.getItem('editalEscolhido')) || null,
        inscricaoId: null,
        vagaId: null,
        protocolo: '',
        aceiteTermos: false,
        etapaAtual: 'inscricao-dados-pessoais',
        // EtapaInscricao do backend (1 a 8) â decide onde o candidato retoma a jornada.
        etapaProcesso: null,
        dadosPessoais: {
            rg: '',
            rqe: '',
            dataNascimento: '',
            sexo: '',
            estadoCivil: '',
            telefone: '',
            celular: '',
            whatsapp: '',
            whatsappMesmoCelular: true,
        },
        enderecoResidencial: {
            cep: '',
            rua: '',
            numero: '',
            complemento: '',
            bairro: '',
            cidade: '',
            uf: '',
        },
        locaisAtendimento: [],
        especialidade: {
            especialidadeId: '',
            areaAtuacao: '',
            rqe: '',
            municipioVaga: '',
        },
        formacoes: [],
        experiencias: [],
        documentos: {},
        pagamento: null,
        revisaoPrimeiraEtapaSolicitada: false,
        revisaoPrimeiraEtapaJustificativa: '',
        presencaCursoConfirmada: false,
        presencaCursoConfirmadaEm: null,
        presencaCursoConfirmadaPor: '',
        nivelamentoConcluido: false,
    },

    documentosExigidos: [],

    indicadores: null,
    listaInscricoes: [],
    listaEditais: [],
    listaTiposDocumento: [],
    catalogoTiposDocumento: [],
    listaEspecialidades: [],
    listaAreasAtuacao: [],
    listaUsuarios: [],
    listaPagamentos: [],
};
